<aside id="sidebar">


    <div id="sidebar-wrap">

        <div class="panel-group slim-scroll" role="tablist">
            <div class="panel panel-default">
                <div class="panel-heading" role="tab">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" href="#sidebarNav">
                            Navigation <i class="fa fa-angle-up"></i>
                        </a>
                    </h4>
                </div>
                <div id="sidebarNav" class="panel-collapse collapse in" role="tabpanel">
                    <div class="panel-body">

                        <ul id="navigation">
                            <li routerLinkActive="active">
                                <a [routerLink]="['/super/'+AppFrontRoutes.SDASHBOARD]">
                                    <i class="fa fa-dashboard"></i> 
                                    <span>SuperAdmin</span>
                                </a>
                            </li>

                            <li routerLinkActive="active">
                                <a [routerLink]="['/super/'+AppFrontRoutes.INSTALLATION_LIST]">
                                    <i class="fa fa-exclamation-circle"></i> 
                                    <span> Installation List </span>
                                </a>
                            </li>

                            <li routerLinkActive="active">
                                <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_LANG]">
                                    <i class="fa fa-share"></i>
                                    <span>Language Modules</span>
                                </a>
                            </li>
                            
                            <li routerLinkActive="active">
                                <a [routerLink]="['/super/'+AppFrontRoutes.SUPER_ADMIN_MAIL_CONFIG]">
                                    <i class="fa fa-cog"></i> 
                                    <span>Configuration and Email</span>
                                </a>
                            </li>
                            
                            <li routerLinkActive="active">
                                <a [routerLink]="['/super/'+AppFrontRoutes.ADMIN_TICKET_LIST]">
                                    <i class="fa fa-user"></i> 
                                    <span>Support Tickets</span>
                                </a>
                            </li>        
                            
                            <li routerLinkActive="active">
                                <a [routerLink]="['/super/'+AppFrontRoutes.ADMIN_PACKAGE_LIST]">
                                    <i class="fa fa-user"></i> 
                                    <span>Package Configuration</span>
                                </a>
                            </li>                                    
                        </ul>
                        <!--/ NAVIGATION Content -->


                    </div>
                </div>
            </div>

        </div>

    </div>


</aside>